import { EventBatchManager } from '@accedo/one-plugin-sdk';

import { axios } from '#/client/axios';
import { MainConfig } from '#/service/config/config.types';
import { ignoreError } from '#/service/utils';

/**
 * Singleton instance of EventBatchManager
 */
let eventBatchManagerInstance: EventBatchManager | undefined;

/**
 * Initialize the EventBatchManager singleton
 * Should be called once during app bootstrap
 */
export const initEventBatchManager = (config: MainConfig): void => {
  const eventBatchConfig = config.featureConfig?.analytics?.eventBatch;
  const endpoint = eventBatchConfig?.endpoint;

  // Only initialize if config exists and not already initialized
  if (eventBatchConfig && !eventBatchManagerInstance && endpoint) {
    eventBatchManagerInstance = new EventBatchManager({
      ...eventBatchConfig,
      onBatchReady: (batch) => {
        axios
          .post(endpoint, batch, {
            headers: {
              'Content-Type': 'application/json',
              'Content-Encoding': 'gzip',
            },
          })
          .catch((error) => {
            ignoreError(error);
          });
      },
    });
  }
};

/**
 * Get the EventBatchManager singleton instance
 * @returns The EventBatchManager instance, or undefined if not initialized
 */
export const getEventBatchManager = () => {
  return eventBatchManagerInstance;
};

/**
 * Cleanup the EventBatchManager
 * Should be called everytime we need to send events manually
 * For instance, leaving a playback page while we still keep
 * events in the memory.
 */
export const cleanupEventBatchManager = (): void => {
  if (eventBatchManagerInstance) {
    eventBatchManagerInstance.cleanup();
  }
};

/**
 * Reset the EventBatchManager singleton instance
 * FOR TESTING PURPOSES ONLY
 * @internal
 */
export const resetEventBatchManagerForTesting = (): void => {
  eventBatchManagerInstance = undefined;
};
